export enum ExpenseType {
  Food = 'Food',
  Rent = 'Rent',
  Travel = 'Travel',
  Shopping = 'Shopping',
  Studies = 'Studies',
  Snack = 'Snack',
  Extras = 'Extras',
  Family = 'Family',
  Misc = 'Misc',
}
